<template>
    <svg class="spin-the-wheel__svg" viewBox="0 0 100 100" :class="{ 'spin-the-wheel__svg--spinning': isSpinning }"
        :style="wheelStyle">
        
        <defs>
            <radialGradient id="inner-shadow-gradient" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                <stop offset="0%" stop-color="transparent" />
                <stop offset="89%" stop-color="transparent" />
                <stop offset="90%" stop-color="rgba(255,255,255,0.0)" />
                <stop offset="95%" stop-color="rgba(255,255,255,0.4)" />
                <stop offset="100%" stop-color="rgba(255,255,255,0.8)" />
            </radialGradient>

            <radialGradient id="pink-gradient" gradientUnits="userSpaceOnUse" cx="50" cy="50" r="50">
                <stop offset="75%" stop-color="#FF007F" />
                <stop offset="100%" stop-color="#FF80C0" />
            </radialGradient>

            <radialGradient id="blue-gradient" gradientUnits="userSpaceOnUse" cx="50" cy="50" r="50">
                <stop offset="75%" stop-color="#007BFF" />
                <stop offset="100%" stop-color="#80D4FF" />
            </radialGradient>

            <radialGradient id="golden-gradient" gradientUnits="userSpaceOnUse" cx="50" cy="50" r="50">
                <stop offset="75%" stop-color="#FFB417" />
                <stop offset="100%" stop-color="#FFB417" />
            </radialGradient>
        </defs>


        <g>
            <path v-for="(segment, index) in segments" :key="index"
                :d="describeArc(50, 50, 50, index * segmentAngle, (index + 1) * segmentAngle)"
                :fill="getSegmentFill(index)" />


            <g v-for="(segment, index) in segments" :key="`text-group-${index}`">
                <g v-if="!isSpinning && index === selectedSegmentIndex"
                    :transform="`translate(${getTextX(index) - 3.1}, ${getTextY(index) - 2.9}) scale(0.2) rotate(${index * segmentAngle + segmentAngle / 2 + 360}, 14, 14)`"
                    fill="white">
                    <rect y="1.90735e-06" width="28" height="28" rx="14" fill="white" />
                    <path d="M20.0669 9.45L11.7253 17.7917L7.93359 14" stroke="#FFB417" stroke-width="2.73"
                        stroke-linecap="round" stroke-linejoin="round" />
                </g>


                <text :x="getTextX(index)" :y="getTextY(index)" text-anchor="start" dominant-baseline="middle"
                    fill="white" font-size="3.9" font-weight="600"
                    :transform="`rotate(${index * segmentAngle + segmentAngle / 2 + 90}, ${getTextX(index)}, ${getTextY(index)})`">
                    <tspan :dx="!isSpinning && index === selectedSegmentIndex ? '4' : '0'">{{ segment.text }}</tspan>
                </text>
            </g>
        </g>



        <circle cx="50" cy="50" r="50" fill="url(#inner-shadow-gradient)" />

    </svg>
</template>



<script setup>

import { computed } from 'vue';

const props = defineProps({
    segments: {
        type: Array,
        required: true
    },
    isSpinning: {
        type: Boolean,
        required: true
    },
    endRotation: {
        type: Number,
        required: true
    },
    finalRotation: {
        type: Number,
        required: true
    },
    selectedSegmentIndex: {
        type: Number,
        default: -1
    }
});

const segmentAngle = computed(() => 360 / props.segments.length);

const wheelStyle = computed(() => {
    return {
        '--end-rotation': `${props.endRotation}deg`,
        transform: props.isSpinning
            ? ''
            : `rotate(${props.finalRotation}deg)`
    };
});

const describeArc = (x, y, radius, startAngle, endAngle) => {
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    return [
        'M', start.x, start.y,
        'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        'L', x, y,
        'Z'
    ].join(' ');
};

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};

const getTextX = (index) => {
    const angle = (index * segmentAngle.value + segmentAngle.value / 2) * (Math.PI / 180);
    return 50 + 42 * Math.cos(angle - Math.PI / 2);
};

const getTextY = (index) => {
    const angle = (index * segmentAngle.value + segmentAngle.value / 2) * (Math.PI / 180);
    return 50 + 42 * Math.sin(angle - Math.PI / 2);
};

const getSegmentFill = (index) => {
    if (!props.isSpinning && index === props.selectedSegmentIndex) {
        return 'url(#golden-gradient)';
    }
    return index % 2 === 0 ? 'url(#pink-gradient)' : 'url(#blue-gradient)';
};

</script>